import { useEffect, useRef } from "react";

export function MotionBg({ variant, dots = 0 }) {
  return (
    <div className={`motion-bg motion-${variant}`} aria-hidden="true">
      {Array.from({ length: dots }, (_, i) => `${variant}-dot-${i}`).map((id) => (
        <i key={id} />
      ))}
    </div>
  );
}

export function InteractiveSection({ as = "section", className = "", children, ...rest }) {
  const ref = useRef(null);
  useEffect(() => {
    const node = ref.current;
    if (!node || !window.matchMedia("(pointer: fine)").matches) return undefined;
    const onMove = (event) => {
      const rect = node.getBoundingClientRect();
      node.style.setProperty("--mx", `${event.clientX - rect.left}px`);
      node.style.setProperty("--my", `${event.clientY - rect.top}px`);
    };
    node.addEventListener("pointermove", onMove, { passive: true });
    return () => node.removeEventListener("pointermove", onMove);
  }, []);
  const Tag = as;
  return (
    <Tag ref={ref} className={`interactive-section ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
